import React from 'react';
import i18next from 'i18next';
import { Helmet } from 'react-helmet';
import tags from '../../helpers/metadata.json';
import image from '../../assets/images/Preview.png';

const { title, description } = tags;

export function Seo() {
  const { language } = i18next;

  const isUK = language.substring(0, 2) === 'uk';

  const actualDescription = isUK
    ? description.uk
    : description.ru;

  const url =
    typeof window !== 'undefined'
      ? window.location.href
      : '/';
  const meta = ['og', 'twitter']
    .map((el) => {
      return [
        {
          property: `${el}:title`,
          content: title,
        },
        {
          property: `${el}:description`,
          content: actualDescription,
        },
        {
          property: `${el}:url`,
          content: url,
        },
        {
          property: `${el}:image`,
          content: `${url.slice(0, -1)}${image}`,
        },
      ]
        .concat([
          { property: `og:type`, content: 'website' },
        ])
        .concat({
          name: `twitter:card`,
          content: 'summary_large_image',
        })
        .concat({
          name: 'description',
          content: actualDescription,
        });
    })
    .flat();

  return <Helmet title={title} meta={meta} />;
}
